import { TextInputField } from './TextInputField'
import { withTextInputField } from './withTextInputField'

const ConnectedTextInputField = withTextInputField(TextInputField)

export { ConnectedTextInputField as TextInputField }
